const M = [
  {
    name: "welcome",
    zh: "欢迎来到易付宝！",
    en: "Welcome to eepay!"
  },
  {
    name: "WeChatLogin",
    zh: "微信登录",
    en: "WeChat login"
  },
  {
    name: "facebookLogin",
    zh: "Facebook登录",
    en: "Facebook Login"
  },
  {
    name: "agreementTips",
    zh: "注册即代表同意关于易付宝的《服务协议》",
    en: 'Registration represents agree with the "service agreement" of eepay'
  },
  {
    name: "userServiceAgreement",
    zh: "用户服务协议",
    en: "User service agreement"
  },
  {
    name: "loginName",
    zh: "账号/手机登录",
    en: "Account / Mobile Login"
  },
  {
    name: "accountLogin",
    zh: "账号登录",
    en: "Account Login"
  },
  {
    name: "mobileLogin",
    zh: "手机号码登录",
    en: "Mobile Login"
  },
  {
    name: "rememberPassword",
    zh: "记住密码",
    en: "Remember"
  },
  {
    name: "accountRegistration",
    zh: "账号注册",
    en: "Account Registration"
  },
  {
    name: "MailboxBound",
    zh: "已绑定邮箱",
    en: "Mailbox bound"
  },
  {
    name: "emailResetPsd",
    zh: "可通过邮箱地址重置密码",
    en: "Password reset via email address"
  },
  {
    name: "securitySet",
    zh: "已设置密保",
    en: "Security protection has been set"
  },
  {
    name: "securityResetPsd",
    zh: "可通过回答密保问题重置密码",
    en: "You can reset the password by answering the security question"
  },
  {
    name: "fillAccount",
    zh: "请填写您的易付宝账号",
    en: "Fill in your eepay account"
  }
];

export default M;
